<template>
  <div class="validation-buttons">
    <b-button
      variant="outline-secondary"
      size="sm"
      class="mr-1 approve"
      :class="{ active: selected === 'approved' }"
      @click="select('approved')"
    >
      <b-icon-check />
    </b-button>

    <b-button
      variant="outline-secondary"
      size="sm"
      class="reject"
      :class="{ active: selected === 'rejected' }"
      @click="select('rejected')"
    >
      <b-icon-x />
    </b-button>
  </div>
</template>

<script>
import { BIconCheck, BIconX } from 'bootstrap-vue'

export default {
  name: 'LocationValidation',
  components: { BIconCheck, BIconX },
  props: {
    initial: {
      type: String,
      default: null,
    },
  },
  data() {
    return { selected: this.initial }
  },
  watch: {
    initial(newVal) {
      this.selected = newVal
    },
  },
  methods: {
    select(status) {
      this.selected = status
      this.$emit('validation', status)
    },
  },
}
</script>

<style scoped lang="scss">
.validation-buttons {
  display: flex;
  align-items: center;

  .btn {
    transition: all 0.2s ease-in-out;

    &:hover {
      transform: scale(1.1);
      &.approve { background-color: #28a745 }
      &.reject { background-color: #dc3545 }
    }
  }

  .btn.active:nth-child(1) { background-color: #28a745 }

  .btn.active:nth-child(2) { background-color: #dc3545 }
}
</style>
